import React, { useState, useEffect } from 'react';
import { getLocale, useIntl } from 'umi';
import { Card, Button, Checkbox } from 'tea-component';
import SelectMultiple from '@/pages/intelligence/pages/Compare/PcConsoleGames/components/SelectMultiple';
import RegionSelector from '@/pages/intelligence/components/RegionSelector';
import { isArrayValueSame } from '../../../../utils';
import { REGION_SELECTOR_RADIOS, PERIODS_METRICS_CONFIG, DEVICES_NAMES_MAPPING } from '../../../../constants';
import type { IBaseProps, IRegionType, IRegionValue } from '@/pages/intelligence/types/common';
import type { IFilter, IRegion } from '@/pages/intelligence/types/pcConsoleCompare';

const { DEVICES } = PERIODS_METRICS_CONFIG.MAU;

const DEVICES_OPTIONS = DEVICES.map((item) => ({
  text: DEVICES_NAMES_MAPPING?.[item] || item || '',
  value: item,
}));

interface IFilterProps extends IBaseProps {
  metrics: string[];
  regionsCountries: IRegion[];
  filter: IFilter;
  onChange: (payload: IFilter, isTablesNeedReReq: boolean, isTrendsNeedReReq: boolean) => void;
}

export default function Filter(props: IFilterProps) {
  const { metrics, regionsCountries = [], filter: filterOutter, onChange: onChangeOutter, handleReset: handleResetOutter } = props;

  const { formatMessage } = useIntl();

  const locale = getLocale();

  const [filter, setFilter] = useState<IFilter>({
    metrics: [...metrics],
    devices: [...DEVICES],
    regionData: {
      type: 'market',
      regions: [],
      markets: ['global'],
    },
    isHeatMap: false,
    isShowTop3Countries: false,
  });
  useEffect(() => {
    setFilter({
      ...filter,
      ...filterOutter,
    });
  }, [filterOutter]);

  const handleDevicesChange = (payload: string[]) => {
    const filterTemp = {
      ...filter,
      devices: Array.isArray(payload) ? payload : [],
    };
    setFilter(filterTemp);
  };

  const handleRegionCountryChange = (value: { type: IRegionType; regions: IRegionValue; markets: IRegionValue }) => {
    const regionDataTemp = {
      ...filter?.regionData,
      type: value?.type || 'market',
      regions: value?.regions || [],
      markets: value?.markets || [],
    };
    const filterTemp = {
      ...filter,
      regionData: regionDataTemp,
    };
    setFilter(filterTemp);
  };

  const handleIsHeatMapChange = (payload: boolean) => {
    const filterTemp = {
      ...filter,
      isHeatMap: payload,
    };
    setFilter(filterTemp);
  };

  const handleIsShowTop3CountriesChange = (payload: boolean) => {
    const filterTemp = {
      ...filter,
      isShowTop3Countries: payload,
    };
    setFilter(filterTemp);
  };

  const handleConfirm = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    // 数据项筛选，这些条件变化，肯定需要重新请求 对标表格、折线图、指标累计值数据
    const isDataFilterChange =
      !isArrayValueSame(filter?.devices, filterOutter?.devices) ||
      filter?.regionData?.type !== filterOutter?.regionData?.type ||
      !isArrayValueSame(filter?.regionData?.regions, filterOutter?.regionData?.regions) ||
      !isArrayValueSame(filter?.regionData?.markets, filterOutter?.regionData?.markets);
    // 所有筛选条件都没变化，直接点确定，需要重新请求 对标表格、折线图、指标累计值数据
    const isNeedsReReq =
      !isDataFilterChange &&
      filterOutter?.isHeatMap === filter?.isHeatMap &&
      filterOutter?.isShowTop3Countries === filter?.isShowTop3Countries;
    // 是否需要重新请求 对比表格的数据
    const isTablesNeedReReq =
      isNeedsReReq || isDataFilterChange || (!filterOutter?.isShowTop3Countries && !!filter?.isShowTop3Countries);
    // 是否需要重新请求 折线图、指标累计值的数据
    const isTrendsNeedReReq = isNeedsReReq || isDataFilterChange;
    onChangeOutter?.(filter, isTablesNeedReReq, isTrendsNeedReReq);
  };

  const handleReset = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    setFilter({
      ...filter,
      devices: [...DEVICES],
      regionData: {
        type: 'market',
        regions: [],
        markets: ['global'],
      },
      isHeatMap: false,
      isShowTop3Countries: false,
    });
    handleResetOutter?.()
  };

  return (
    <Card className="dbi-pc-console-compare_filter">
      <Card.Body>
        <div className="dbi-filter">
          <SelectMultiple
            className="dbi-pc-console-compare_filter-control-item search-item"
            label={formatMessage({ id: 'dbi_compare_label_device' })}
            options={DEVICES_OPTIONS}
            value={filter?.devices}
            onChange={handleDevicesChange}
          />
          <RegionSelector
            key="dbi-pc-console-compare-region"
            className="dbi-pc-console-compare_filter-control-item search-item dbi-pc-console-compare_region-selector"
            style={{ marginRight: 20 }}
            locale={locale}
            // popularList={[]}
            radioOptions={REGION_SELECTOR_RADIOS}
            options={regionsCountries}
            value={{
              ...filter?.regionData,
              extendFilterType: 'common',
            }}
            entityType={'combine'}
            onConfirm={handleRegionCountryChange}
            // onCloseReginSelect={(value) => {
            //   console.log('[ value ] >', value);
            // }}
          />
          <div className="dbi-filter-checkbox-container search-item">
            <Checkbox value={filter?.isHeatMap} onChange={handleIsHeatMapChange}>
              {formatMessage({ id: 'dbi_compare_heat_map' })}
            </Checkbox>
            <Checkbox value={filter?.isShowTop3Countries} onChange={handleIsShowTop3CountriesChange}>
              {formatMessage({ id: 'dbi_compare_show_top_3_countries' })}
            </Checkbox>
          </div>
        </div>
        <div className="dbi-filter-btn">
          <Button type="primary" className="dbi-filter-btn-lf" onClick={handleConfirm}>
            {formatMessage({ id: 'dbi_confirm' })}
          </Button>
          <Button type="weak" onClick={handleReset}>
            {formatMessage({ id: 'dbi_reset' })}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
